// extracted by mini-css-extract-plugin
export default {"selector":"pW9yl","icon":"Ilgte","selectorOptions":"FXmJ9","selectorOption":"TRnWF","employeeEdit":"zNXC6","employeeFilters":"T2alg"};